enum OutletType {
  BoxOffice = 'BoxOffice',
  Remote  = 'Remote',
  Web = 'Web',
  CallCenter = 'CallCenter',
  BackOffice = 'BackOffice',
  YieldManagerPrimary = 'YieldManagerPrimary',
}
export { OutletType };
